export const SET_RESPONDENT = 'SET_RESPONDENT'
export const setRespondent = respondent => ({
    type: SET_RESPONDENT,
    payload: {respondent}
})


// WEBPACK FOOTER //
// ./src/actions/respondent.js